import type { ThemePreference } from "./api/types.js";
import { initialThemePreference } from "./app/theme-preference.js";

const preference: ThemePreference = initialThemePreference(window.localStorage);
const resolved =
  preference === "system"
    ? window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "vantablack"
      : "light"
    : preference;
document.documentElement.setAttribute("data-theme", resolved);
document.documentElement.setAttribute("data-theme-preference", preference);
